import { createAction, props } from '@ngrx/store';
import { SuiSortState as Sort } from '@semeris/ui';

import { SimilarParagraphViewModel } from '../../features/similar-paragraph/models/similar-paragraph.view-model';

export namespace SimilarParagraphActions {
  export const SearchSimilarParagraphs = createAction('[SimilarParagraph] Search Similar Paragraphs', props<{ searchText?: string }>());
  export const SearchSimilarParagraphsSuccess = createAction(
    '[SimilarParagraph] Search Similar Success Success',
    props<{ list: SimilarParagraphViewModel[]; searchedDealCount: number }>(),
  );
  export const SearchSimilarParagraphsFail = createAction('[SimilarParagraph] Search Similar Fail Fail', props<{ error: string }>());
  export const ExpandDeal = createAction('[SimilarParagraph] Expand Deal', props<{ transactionId: string }>());
  export const ExpandDealSuccess = createAction(
    '[SimilarParagraph] Expand Deal Success',
    props<{ transactionId: string; list: SimilarParagraphViewModel[] }>(),
  );
  export const ExpandDealFail = createAction('[SimilarParagraph] Expand Deal Fail', props<{ transactionId: string; error: string }>());
  export const CollapseDeal = createAction('[SimilarParagraph] Collapse Deal', props<{ transactionId: string }>());
  export const SetSort = createAction('[SimilarParagraph] Search Similar Set Sort', props<{ sort: Sort }>());
  export const SetShowDiff = createAction('[SimilarParagraph] Set Show Diff', props<{ showDiff: boolean }>());
  export const SetShowBaseline = createAction('[SimilarParagraph] Set Show Baseline', props<{ showBaseline: boolean }>());
  export const SetGroupByDeal = createAction('[SimilarParagraph] Set Group By Deal', props<{ groupByDeal: boolean }>());
}
